import GS from '../../../grafsync/grafsync';
import { handleResponse } from './handleResponse';

async function doRefresh() {
    const endpoint = process.env.REACT_APP_API_URL;
    let headers = {
        "Accept": "application/ld+json",
        "Accept-encoding": "gzip, deflate"
    };
    // We include the refresh token and user cookies if set
    const res = await fetch(endpoint + "/authenticate/refresh", {
        method: 'GET',
        headers: new Headers(headers),
        credentials: 'include',
        mode: 'cors',
        cache: 'default'
    });
    if (res.ok) {
        const userData = await res.json();
        return userData;
    }
    else {
        return false;
    }
}

async function login(username, password) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, source: "browser" }),
        credentials: 'include',
        mode: 'cors',
        cache: 'no-cache'
    };
    return fetch(`${process.env.REACT_APP_API_URL}/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user;
        });
}

async function forgottenPassword(username) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username }),
        mode: 'cors',
        cache: 'no-cache'
    };
    return fetch(`${process.env.REACT_APP_API_URL}/authenticate/forgotten`, requestOptions)
        .then(handleResponse);
}

async function forgottenUsername(email) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
        mode: 'cors',
        cache: 'no-cache'
    };
    return fetch(`${process.env.REACT_APP_API_URL}/authenticate/forgottenusername`, requestOptions)
        .then(handleResponse);
}

async function resetPassword(password, token) {

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer " + token
        },
        body: JSON.stringify({ password }),
        mode: 'cors',
        cache: 'no-cache'
    };
    return fetch(`${process.env.REACT_APP_API_URL}/authenticate/resetpassword`, requestOptions)
        .then(handleResponse);
}

async function logout(isSSOuser = false) {
    let logoutData;
    try {
        // Now logout user at API layer
        logoutData = await GS.logout();
    }
    catch (e) {
        console.log(e)// eslint-disable-line    
        logoutData = null;
    }
    // Clean up the application
    await GS.exit();
    const ssoEnabled = window.Graphologi.sso;
    // If we're already logged out logoutData might be null
    if (ssoEnabled && isSSOuser && logoutData) {
        const logoutURL = logoutData.logoutURL;
        // Finally log out of SSO if applicable
        if (logoutURL) {
            window.location.href = logoutURL;
        }
        else {
            console.log("No logout URL so redirecting to home page")// eslint-disable-line 
            window.location.href = "/";
        }
    }
}

export const authenticationService = {
    login,
    logout,
    doRefresh,
    forgottenPassword,
    forgottenUsername,
    resetPassword
};
